import { createSlice } from '@reduxjs/toolkit';
const staticSettingSlice = createSlice({
  name: 'staticSettingSlice',
  initialState: {
    data: null,   
    status:false,
  },
  reducers: {
    loadStoreSettingSlice(state, action) {
      state.data = action.payload;
      state.status = true;           
    },
   


  },
});

export const { loadStoreSettingSlice } = staticSettingSlice.actions;
export default staticSettingSlice.reducer;